import { DatePicker, Form, FormInstance, Radio } from "antd";
import { useMemo } from "react";
import { IOption } from "../../../../../types/Option";
import { DATE_FORMAT } from "../../../../../lib/constants";
import dayjs from "dayjs";
import { FormButtons } from "./FormButtons";
import { useExport } from "../hooks/useExport";

const { RangePicker } = DatePicker;

type FormItemsProps = {
  form: FormInstance;
  closeModal: () => void;
};

export const FormItems = ({ form, closeModal }: FormItemsProps) => {
  const type = Form.useWatch("dateRangeType", form);

  const initialValues = useMemo(() => {
    const now = dayjs();

    return {
      dates: [now, now],
      dateRangeType: 1,
    };
  }, []);

  const options: IOption[] = useMemo(
    () => [
      {
        value: 1,
        label: "Any",
      },
      {
        value: 2,
        label: "This Week",
      },
      {
        value: 3,
        label: "This Month",
      },
      {
        value: 4,
        label: "This Year",
      },
      {
        value: 5,
        label: "Custom Range",
      },
    ],
    [],
  );

  const { onExport, isLoading } = useExport(form, closeModal);

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        className="pt-6 processing-print-form"
        initialValues={initialValues}
        disabled={isLoading}
      >
        <Form.Item label="Incident Date" name="dateRangeType" className="mb-4">
          <Radio.Group
            className="d-flex flex-column visibility-options"
            options={options}
          />
        </Form.Item>
        {type === 5 && (
          <Form.Item className="mb-4 w-100" label="" name="dates">
            <RangePicker
              className="w-100"
              format={DATE_FORMAT}
              allowClear={false}
            />
          </Form.Item>
        )}
      </Form>
      <FormButtons
        isLoading={isLoading}
        onExport={onExport}
        closeModal={closeModal}
      />
    </>
  );
};
